import React, {useCallback} from 'react';
import {WebSocketOperationButton} from "../../components/web-socket/WebSocketOperationButton";
import {useCurrentOfficeStore} from "../../api/CurrentOfficeStore";
import {PRAGUE_OFFICE_ID} from "../../util/OfficePath";
import GoogleIcon from "@mui/icons-material/Google";
import {useVisitReportStore} from "../../api/VisitReportStore";

export function ImportPragueVisitReportsButton() {
    const currentOfficeId = useCurrentOfficeStore(state => state.officeId);
    const refreshReports = useVisitReportStore(state => state.refresh);

    const handleFinish = useCallback(() => {
        refreshReports();
    }, [refreshReports]);

    return currentOfficeId === PRAGUE_OFFICE_ID ? (
        <WebSocketOperationButton
            endpoint={`/api/operations/offices/${currentOfficeId}/import-visit-reports`}
            variant="outlined"
            description="Import Prague visit report data from the Google Drive"
            actionButtonLabel="Import"
            icon={<GoogleIcon/>}
            onFinish={handleFinish}
        />
    ) : null;
}
